import React from 'react';
import { Snackbar, Alert } from '@mui/material';

interface ToastProps {
  isOpen: boolean;
  onClose: (arg?: any) => void;
  message: string | null;
  severity?: 'success' | 'error' | 'info' | 'warning';
  anchorOrigin?: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
}
const Toast = ({ isOpen, onClose, message, anchorOrigin = { vertical: 'bottom', horizontal: 'right' }, severity = 'info' }: ToastProps) => {
  const handleClose = (_?: Event | React.SyntheticEvent, reason?: string): void => {
    if (reason === 'clickaway') {
      return;
    }
    onClose?.();
  };


  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        severity={severity}
        variant="filled"
        onClose={handleClose}
      >
        {message?.toString()}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
